<template>
  <road-book-edit ref="roadBookEdit"></road-book-edit>
</template>
<script>
import roadBookEdit from "./components/editRoadBook";
export default {
  name: "addRoadBooks",
  components: { roadBookEdit },
  activated() {
    if (this.$route.params.refresh) {
      this.$refs.roadBookEdit.refreshData();
    }
  }
};
</script>
